import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';

const DefaultButton = ({ ...rest }: ButtonProps) => <Button {...rest} />;
export default DefaultButton;
